/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { environment } from 'utils/environment';

////--=-=-=-=-= This utils purpose is to return true if it is after 4pm and false if it isnt -=-=-=-=-=-=/////



export const isAfterFourPM = () => {
    const date = new Date();
    const time = date.getUTCHours();
    const hour = environment === 'PRODUCTION' ? 20 : 13;
    return time >= hour;
};